import { Features, type FeatureAccessMap, type FeatureConfig } from './types';

export const FEATURE_CONFIG: readonly FeatureConfig[] = [
  { key: Features.FEATURE_ASSETS, name: 'Assets' },
  { key: Features.FEATURE_ZONES, name: 'Zones' },
  { key: Features.FEATURE_CATEGORIES, name: 'Categories' },
  { key: Features.FEATURE_RENT, name: 'Rent' },
  { key: Features.FEATURE_CONTRACTORS, name: 'Contractors' },
  {
    key: Features.FEATURE_CONTRACTOR_AVAILABILITY,
    name: '- Contractor Availability',
  },
  {
    key: Features.FEATURE_CONTRACTOR_PROXIMITY,
    name: '- Contractor proximity',
  },
  { key: Features.FEATURE_ISSUES, name: 'Issues' },
  { key: Features.FEATURE_WORK_ORDERS, name: 'Works' },
  {
    key: Features.FEATURE_WORK_AVAILABILITY,
    name: '- Work Availability',
  },
  { key: Features.FEATURE_ORDERS, name: 'Orders' },
  { key: Features.FEATURE_ORDER_ASSET, name: '- Order Asset' },
  { key: Features.FEATURE_ORDER_TEMPLATES, name: ' - Order Templates' },
  { key: Features.FEATURE_QR_CODES, name: 'QR Codes' },
  { key: Features.FEATURE_CALENDAR, name: 'Calendar' },
  { key: Features.FEATURE_TIMESHEET, name: 'Timesheet' },
  { key: Features.FEATURE_WORKFLOWS, name: 'Workflows' },
  { key: Features.FEATURE_WORK_OFFERS, name: 'Work Offers' },
  { key: Features.FEATURE_REPORTS, name: 'Reports' },
  { key: Features.FEATURE_ASSET_HIERARCHY, name: 'Asset Hierarchy' },
  {
    key: Features.FEATURE_HIDE_WORK_ADVANCED_FILTERS,
    name: 'Hide Work Advanced Filters',
  },
];

export const DEFAULT_FEATURE_ACCESS: FeatureAccessMap = Object.values(
  Features
).reduce((acc, feature) => {
  acc[feature] = false;
  return acc;
}, {} as FeatureAccessMap);
